module.exports = __webpack_public_path__ + "img/Menu-01.cd986bf3.png";